import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getXmotBrands,
  getXmotSegments,
  getXmptParticipantList,
} from "../../../../../services/xmotSurvey/survey";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { ProgressSpinner } from "primereact/progressspinner";
const genderOptions = [
  { name: "Male", code: "male" },
  { name: "Female", code: "female" },
  { name: "Non-binary", code: "non-binary" },
  { name: "All", code: "all" },
];

const ageOptions = [
  { name: "18-24", code: "18-24" },
  { name: "25-34", code: "25-34" },
  { name: "35-44", code: "35-44" },
  { name: "45-54", code: "45-54" },
  { name: "55-64", code: "55-64" },
  { name: "65+", code: "65-75" },
];

const segmentsDataValue = [
  "$100,000-$149,999",
  "$150,000 or more",
  "$150,000+",
  "$25,000-$49,999",
  "$50,000-$74,999",
  "$75,000-$99,999",
  "1",
  "1 people",
  "18-24",
  "2",
  "2 people",
  "25-34",
  "3",
  "3 people",
  "35-44",
  "4 or more",
  "4+ people",
  "45-54",
  "45+",
  "55-64",
  "65 or more",
  "65+",
  "Black or African American",
  "Caucasian/White",
  "Children <11 present",
  "Children 11-17 present",
  "Children 18+ present",
  "Children not present",
  "Chinese American",
  "Hispanic/Latino",
  "KIDS < 18 PRESENT",
  "Multiethnic",
  "Multiethnic",
  "Native American/Inuit/Aleut",
  "NO KIDS < 18",
  "Other",
  "Other Asian American or Pacific Islander",
  "Pet(s) not present",
  "Pet(s) present",
  "Prefer Not to Answer",
  "Prefer Not to Say",
  "South Asian American",
];

const Participants = ({
  errors,
  xmotFormData,
  handleXmotFormChange,
  finalStudyId,
  trigger_type,
  mappedCategory,
  isEditMode,
  loading,
}) => {
  const {
    participants,
    xmotItem: productType,
    selectedDropdownValue: productId,
    seletedCustomRecruit,
  } = xmotFormData;
  const {
    selectedSegment,
    selectedGender,
    selectedAgeRange,
    selectedBrand,
    participantsValues = [],
  } = participants;
  const { recruit_value } = seletedCustomRecruit;
  const { user, token } = useSelector((state) => state.auth);
  const [isEyeIconOpen, setIsEyeIconOpen] = useState(false);
  const [xmotSegmentsData, setXmotSegmentsData] = useState([]);
  const [xmotBrandsData, setXmotBrandsData] = useState([]);
  const [xmotParticipantData, setXmotParticipantData] = useState([]);
  const [isParticipantFetching, setIsParticipantFetching] = useState(false);

  useEffect(() => {
    getSegmentsForXMOT();
    getParticipantList("", "");
    getBrandsData();
  }, []);

  const parseAgeRange = (range) => {
    if (!range) return null;
    const [from, to] = range.split("-").map(Number);
    return { age_from: from, age_to: to };
  };

  const getParticipantList = async (type, typeValue) => {
    const segmentNames = selectedSegment?.length
      ? [].concat(selectedSegment).join(",")
      : undefined;

    const brandNames = selectedBrand?.length
      ? [].concat(selectedBrand).join(",")
      : undefined;

    const selectedAges = selectedAgeRange?.length
      ? [].concat(selectedAgeRange).join(",")
      : undefined;

    const reqBody = {
      project_id: parseInt(finalStudyId),
      product_id: productId,
      product_type: productType,
      ...(segmentNames && { segments: segmentNames }),
      ...(brandNames && { brands: brandNames }),
      ...(selectedGender && { gender: selectedGender }),
      ...(selectedAges && { age_range: selectedAges }),
    };

    // Type-based overrides
    switch (type) {
      case "gender":
        reqBody.gender = typeValue;
        break;
      case "segments":
        reqBody.segments = typeValue;
        break;
      case "brands":
        reqBody.brands = typeValue;
      case "age_range":
        reqBody.age_range = typeValue;
        break;
      default:
        break;
    }

    try {
      setIsParticipantFetching(true);
      const { status, data } = await getXmptParticipantList(token, reqBody);

      if (status === 200) {
        if (data?.data) {
          const participantData = data?.data ?? [];
          setXmotParticipantData(participantData);
          participants.participantsValues =
            participantData?.map((data) => data.participant_id) ?? [];
          handleXmotFormChange("participants", participants);
        }
      }
    } catch (error) {
      console.error("Error fetching participants:", error);
    } finally {
      setIsParticipantFetching(false);
    }
  };

  const getSegmentsForXMOT = () => {
    const reqBody = {
      project_id: parseInt(finalStudyId),
      product_id: productId,
      product_type: productType,
    };
    getXmotSegments(token, reqBody)
      .then((response) => {
        if (response.status === 200) {
          const segmentsData = response.data.data;
          // const segmentMappedValue = segmentsData?.map((segmentData) => ({ name: segmentData, code: segmentData }));
          setXmotSegmentsData(segmentsData);
        }
      })
      .catch((error) => {
        console.error("Error fetching segments:", error);
      });
  };

  const getBrandsData = async () => {
    const requestBody = {
      project_id: parseInt(finalStudyId),
      mapped_category: mappedCategory,
      product_id: productId,
      product_type: productType,
    };
    try {
      const brandsResponse = await getXmotBrands(token, requestBody);
      const brandsValues = brandsResponse.data?.data || [];
      // const brandMappedValue = brandsValues.length > 0 ? brandsValues.map((brand) => ({ name: brand, code: brand })) : [];
      setXmotBrandsData(brandsValues);
    } catch (err) {
      console.log("err", err);
    }
  };

  const isAllSelected =
    xmotParticipantData?.length > 0
      ? participantsValues.length === xmotParticipantData.length
      : false;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      participants.participantsValues = [];
      handleXmotFormChange("participants", participants);
    } else {
      const participantData = xmotParticipantData.map(
        (data) => data.participant_id,
      );
      participants.participantsValues = participantData;
      handleXmotFormChange("participants", participants);
    }
  };

  const toggleRow = (id) => {
    if (participantsValues?.includes(id)) {
      const newPartValue = participantsValues.filter((i) => i !== id);
      participants.participantsValues = newPartValue;
      handleXmotFormChange("participants", participants);
    } else {
      const newPartValue = [...participantsValues, id];
      participants.participantsValues = newPartValue;
      handleXmotFormChange("participants", participants);
    }
  };

  return (
    <div className="mt-4 text-start">
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
            animationDuration="0.5s"
          />
        </div>
      )}
      <div className="row my-4">
        <div className="col-md-12">
          <div className="form-label fw-600 d-block text-start dark-text">
            Participants
          </div>

          <div className="d-flex flex-column pt-3 mb-5">
            <div className="row mb-4">
              <div
                className="col-md-3"
                style={{ borderRight: "1px solid #d9d4d4" }}
              >
                <label className="form-label fw-600 mb-1 fs-14">
                  Select Segments
                </label>
                <MultiSelect
                  value={selectedSegment}
                  onChange={(e) => {
                    getParticipantList(
                      "segments",
                      e.value.map((item) => item).join(","),
                    );
                    participants.selectedSegment = e.value;
                    handleXmotFormChange("participants", participants);
                  }}
                  options={xmotSegmentsData}
                  optionLabel="name"
                  optionValue="code"
                  display="chip"
                  placeholder="Select by Segments"
                  maxSelectedLabels={2}
                  className={`w-100 inputField ${errors?.selectedSegment ? "error-input" : ""}`}
                  disabled={isParticipantFetching}
                  panelHeaderTemplate={
                    !xmotSegmentsData || xmotSegmentsData.length === 0
                      ? () => null
                      : undefined
                  }
                  selectAllLabel="Select All"
                />
                {errors?.selectedSegment ? (
                  <div className="text-start fs-14 text-danger mb-1">
                    {errors?.selectedSegment}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div
                className="col-md-3"
                style={{ borderRight: "1px solid #d9d4d4" }}
              >
                <label className="form-label fw-600 mb-1 fs-14">
                  Select Gender
                </label>
                <Dropdown
                  value={selectedGender}
                  onChange={(e) => {
                    getParticipantList("gender", e.value);
                    participants.selectedGender = e.value;
                    handleXmotFormChange("participants", participants);
                  }}
                  options={genderOptions}
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Select"
                  className={`w-100 inputField fs-14 ${errors?.selectedGender ? "error-input" : ""}`}
                  disabled={isParticipantFetching}
                />
                {errors?.selectedGender ? (
                  <div className="text-start fs-14 text-danger mb-1">
                    {errors?.selectedGender}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label fw-600 mb-1 fs-14">
                  Select Age Range
                </label>
                <MultiSelect
                  value={selectedAgeRange}
                  onChange={(e) => {
                    getParticipantList(
                      "age_range",
                      e.value.map((item) => item).join(","),
                    );
                    participants.selectedAgeRange = e.value;
                    handleXmotFormChange("participants", participants);
                  }}
                  options={ageOptions}
                  optionLabel="name"
                  optionValue="code"
                  display="chip"
                  placeholder="Select by Age Range"
                  maxSelectedLabels={2}
                  className={`w-100 inputField ${errors?.selectedAgeRange ? "error-input" : ""}`}
                  disabled={isParticipantFetching}
                  panelHeaderTemplate={
                    !ageOptions || ageOptions.length === 0
                      ? () => null
                      : undefined
                  }
                  selectAllLabel="Select All"
                />
                {errors?.selectedAgeRange ? (
                  <div className="text-start fs-14 text-danger mb-1">
                    {errors?.selectedAgeRange}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label className="d-block mb-2 text-dark fs-14">Usage</label>
                <label className="form-label fw-600 mb-1 fs-14">Brand</label>
                <MultiSelect
                  value={selectedBrand}
                  onChange={(e) => {
                    getParticipantList(
                      "brands",
                      e.value.map((item) => item).join(","),
                    );
                    participants.selectedBrand = e.value;
                    handleXmotFormChange("participants", participants);
                  }}
                  options={xmotBrandsData}
                  optionLabel="name"
                  optionValue="code"
                  display="chip"
                  placeholder="Select"
                  maxSelectedLabels={2}
                  className={`w-100 inputField ${errors?.selectedBrand ? "error-input" : ""}`}
                  disabled={isParticipantFetching}
                  panelHeaderTemplate={
                    !xmotBrandsData || xmotBrandsData.length === 0
                      ? () => null
                      : undefined
                  }
                  selectAllLabel="Select All"
                />
                {errors?.selectedBrand ? (
                  <div className="text-start fs-14 text-danger mb-1">
                    {errors?.selectedBrand}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="mt-5 fs-16 d-flex align-items-center justify-content-between">
              <div>
                <span>Base size: </span>
                <span className="text-dark fw-600">
                  {participantsValues?.length} Participants (for this XMOT)
                </span>
              </div>

              {user?.type === "superadmin" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => setIsEyeIconOpen(!isEyeIconOpen)}
                >
                  <span className="text-info">
                    {isEyeIconOpen ? (
                      <i className="pi pi-eye fs-20" />
                    ) : (
                      <i className="pi pi-eye-slash fs-20" />
                    )}
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
            {xmotParticipantData?.length > 0 && isEyeIconOpen ? (
              <>
                <div className="d-flex align-items-center mt-4">
                  <Checkbox
                    inputId={`participant-selectall`}
                    checked={isAllSelected}
                    onChange={toggleSelectAll}
                  />
                  <div className="title ms-2">Select All</div>
                </div>

                <div className="participant-table-wrapper">
                  <table className="table table-borderless clientsTable mt-3">
                    <thead className="clientsTableHead">
                      <tr className="text-muted" style={{ fontSize: "14px" }}>
                        <th style={{ width: "4%" }}></th>
                        <th>Participant Id</th>
                        <th>Participant Name</th>
                        <th>Segments</th>
                      </tr>
                    </thead>

                    <tbody>
                      {xmotParticipantData.map((row, index) => (
                        <tr key={index} style={{ fontSize: "14px" }}>
                          <td>
                            <Checkbox
                              inputId={`participant-${index}`}
                              checked={participantsValues.includes(
                                row.participant_id,
                              )}
                              onChange={() => toggleRow(row.participant_id)}
                            />
                          </td>
                          <td>{row.participant_id}</td>
                          <td>{row.name}</td>
                          <td>{row.segments}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Participants;
